const getApiBaseUrl = () => {
    const hostname = window.location.hostname;

    if (hostname === '192.168.10.12') {
        return 'http://192.168.10.12:8080';
        
    } else if (hostname === 'savplus.dev.kletel.net') {
        return 'https://savplus.dev.kletel.net';

    } else if (hostname === 'eiffage.savplus-btp.com') {
        return 'https://eiffage.savplus-btp.com';

    } else if (hostname === 'vcfprdsav01') {
        return 'https://vcfprdsav01';

    } else if (hostname === 'spie-batignolles.savplus-btp.com') {
        return 'https://spie-batignolles.savplus-btp.com';

    } else if (hostname === 'socotrap.savplus-btp.com') {
        return 'https://socotrap.savplus-btp.com';
    }
    return 'http://localhost:8080';
};

const config = {
    apiBaseUrl: getApiBaseUrl(),
    reactBaseUrl: window.location.origin
};

console.log('API Base URL:', config.apiBaseUrl);

export default config;
